"use client"

import React, { FC } from "react"
import { ChannelLoadingSkeleton } from "../ChannelLoadingSkeleton"
import { MessagesAvatar } from "../MessagesAvatar"
import { Avatar } from "@/elements"

interface Props {}

export const MessageModalLoading: FC<Props> = props => {
  return (
    <div className="order-3 flex h-screen w-full flex-col">
      <div className="flex-grow-1 relative flex h-full w-full flex-col">
        <div className="flex h-full w-full flex-col">
          <div className="flex h-[90px] w-full flex-row items-center border-b border-bg-3 px-7">
            <div className="pr-4">
              <MessagesAvatar src="" alt="" />
            </div>
            <div className="h-[24px] w-[120px] animate-pulse bg-bg-2" />
          </div>
          <div className="relative flex flex-1 flex-col px-7">
            <div className="mt-[36px] flex w-full flex-row justify-center">
              <div className="h-[18px] w-[80px] animate-pulse bg-bg-2" />
            </div>
            <div className="mt-[36px] flex w-full flex-row items-center">
              <Avatar size="sm" />
              <div className="ml-3 h-[36px] w-[90px] animate-pulse rounded-full bg-bg-2" />
            </div>
            <div className="mt-[44px] flex w-full flex-row justify-center">
              <div className="h-[18px] w-[140px] animate-pulse bg-bg-2" />
            </div>
            <div className="mt-[32px] flex w-full flex-row items-center justify-end">
              <div className="h-[36px] w-[110px] animate-pulse rounded-full bg-bg-2" />
            </div>
          </div>
          <div className="flex h-[70px] w-full flex-row flex-nowrap items-center gap-2 px-7">
            <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
            <div className="mx-4 flex h-[40px] flex-1 animate-pulse rounded-full bg-bg-2" />
            <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
            <div className="size-[30px] animate-pulse rounded-[2px] bg-bg-2" />
          </div>
        </div>
      </div>
    </div>
  )
}
